module.exports = __webpack_public_path__ + "static/img/ccovi-logo.b2e9141.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ccovi-logo.svg
// module id = nmqL
// module chunks = 1